export const compactIBAN = (iban: string): string => iban.replace(/[\s-]/g, '').toUpperCase()

export const isValidIBAN = (iban: string): boolean => {
  const ibanRegex = /^[A-Z]{2}[0-9]{2}[A-Z0-9]{1,30}$/
  return ibanRegex.test(iban)
}

export const hasValidIBANChecksum = (iban: string): boolean => {
  const compact = compactIBAN(iban)
  if (!isValidIBAN(compact)) {
    return false
  }

  const rearranged = `${compact.slice(4)}${compact.slice(0, 4)}`
  let remainder = 0
  for (const char of rearranged) {
    const piece = /[A-Z]/.test(char) ? String(char.charCodeAt(0) - 55) : char
    for (const digit of piece) {
      remainder = (remainder * 10 + Number(digit)) % 97
    }
  }
  return remainder === 1
}

export const isGermanIBAN = (iban: string): boolean => {
  const compact = compactIBAN(iban)
  return compact.startsWith('DE') && compact.length === 22 && hasValidIBANChecksum(compact)
}

export const formatIBAN = (iban: string): string =>
  iban
    .replace(/\s/g, '')
    .match(/.{1,4}/g)
    .join(' ')

export const tryFormatIBAN = (iban: string): string => {
  if (isValidIBAN(iban)) {
    return formatIBAN(iban)
  }
  return iban
}

export const formatShortIBAN = (iban: string): string => {
  const cleanIban = iban.replace(/\s/g, '')
  return `${cleanIban.slice(0, 2)} ${'•'.repeat(3)} ${cleanIban.slice(-4)}`
}
